<template>
  <b-row >
    <b-colxx xxs="12">
<!--      <template v-if="modalToggle==1">
        <AlimtalkModal></AlimtalkModal>
      </template>-->
      <template>
        <h1>{{ $t('menu.AlimtalkMng') }}</h1>
        <b-nav class="pt-0 breadcrumb-container d-none d-sm-block d-lg-inline-block">
          <b-breadcrumb>
            <b-breadcrumb-item>{{currentUser.userRole == "BRAND_ADMIN"?'사이트 관리':'매장 관리'}}</b-breadcrumb-item>
            <b-breadcrumb-item>{{currentUser.userRole == "BRAND_ADMIN"?'알림톡 관리':'알림톡 등록 신청'}}</b-breadcrumb-item>
          </b-breadcrumb>

        </b-nav>
<!--        <b-button @click="testItem">페이지 전환</b-button>-->
        <b-row>
          <b-colxx xxs="12" >
            <!--
              리스트 컴포넌트 생성해서 리스트 컴포넌트를 보여주거나 안보여주거나 하는 식으로 진행 해야함 -완-
              브랜드 > 브랜드 리스트 컴포넌트 호출 > 클릭시 추가 액션 노출
              스토어 > 상태에 따른 알림톡신청,검수중,사용중 상태 이미지및 버튼 노출
              -->

            <b-card v-if="adminToggle===0" class="mb-4 col-4" :title="currentUser.userRole == 'BRAND_ADMIN'?'사이트 알림톡':'매장 알림톡'" >
<!--              <label>사이트 알림톡</label>-->
              <div class="text-center">
                <span class=""><i class="iconsminds-mail-read" style="font-size: 80px; color:#870000;" /></span>
                <label class=" h5 text-black-50">클라우드 사이트에서 발송되는 모든 알림을 소유하고 있는 카카오 채널로 이용해 보세요</label>
                <b-button variant="primary" @click="recheckAlimTalk" >등록 신청</b-button>
              </div>
            </b-card>
            <b-card v-if="adminToggle===1" class="mb-4 col-4" :title="currentUser.userRole == 'BRAND_ADMIN'?'사이트 알림톡':'매장 알림톡'" >
              <div class="text-center">
                <label class="d-block"></label>
                <a class="d-block"><i class="iconsminds-sand-watch-2" style="font-size: 80px; color:#870000;" /></a>
                <label class="d-block h5 text-black-50">심사가 완료된 이후 이용이 가능합니다</label>
                <label class="d-block text-danger h2">검수중</label>
              </div>
            </b-card>
            <b-card v-if="adminToggle===2" class="mb-4 col-4" :title="currentUser.userRole == 'BRAND_ADMIN'?'사이트 알림톡':'매장 알림톡'" >
              <div class="text-center">
                <a class="d-block"><i class="iconsminds-speach-bubble" style="font-size: 80px; color:#870000;" /></a>
                <label class="d-block h5 text-black-50" >{{ `클라우드 사이트에서 발송되는 모든 알림톡이 "${kakaoNameLabel}" 채널로 발송 되고 있습니다.` }}</label>
                <b-button variant="primary" @click="brandAlimtalkDisable">사용중지</b-button>
              </div>
            </b-card>
            <b-card v-if="currentUser.userRole == 'BRAND_ADMIN' " class="mb-4" title="매장 알림톡" >
              <label class="h6 text-black-50">클라우드 사이트에서 발송되는 매장 예약, 쿠폰 사용 알림을 소유하고 있는 매장의 카카오 채널로 이용해 보세요</label>
              <alimtalk-list></alimtalk-list>
            </b-card>
          </b-colxx>
        </b-row>
      </template>
    </b-colxx>
  </b-row>
</template>
<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {
  mapGetters,
  mapActions
} from "vuex";
import {
  Chrome,
  Swatches
} from 'vue-color';
import ModalPostcode from "../shop/components/ModalPostcode.vue";
import ModalImage from '../shop/components/ModalImage';
import AlimtalkList from "@/views/siteSet/components/AlimtalkList.vue";
import AlimtalkReg from "@/views/siteSet/components/AlimtalkReg.vue";
import api from '../../constants/api';


export default {
  name: "AlimtalkMng",
    components: {
      Chrome,
      Swatches,
      'v-select': vSelect,
      'modal_postcode': ModalPostcode,
      'modal_image': ModalImage,
      AlimtalkList,
      AlimtalkReg,
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName','info'])
    },
  data(){
      return{
       adminToggle: 0,
       modalToggle: 0,
       basicInfo:{},
       siteInfo:{},
       storeInfo:{},
       brandInfo:{},
       kakaoIdLabel: "",
       kakaoNameLabel: "",
       brandSmsRegister:"",
       brandSendNumber:"",
       brandSmsCertificateDocumentUrl:"",
       brandSmsRegisterDocumentUrl:"",
       storeSmsRegister:"",
       storeSendNumber:"",
       storeSmsCertificateDocumentUrl:"",
       storeSmsRegisterDocumentUrl:"",
       brandCategoryCode:"",




      }
  },
  created() {
      this.getInfo();
      this.getBrandInfo();

  },
  mounted() {



  },
  methods:{
    getInfo(){
      let reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.getBrandInfo)
          const params = {"site_name": this.siteName}

          this.$http.get(reqURL, params, {
            headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
          }).then(res => {
            // ;
            if (res.data.code === "OK") {
              console.log(res)
              this.basicInfo = res.data.data.basicInfo
              this.siteInfo = res.data.data.siteInfo
            } else {
              throw 400
            }
          }).catch(err => {
            alert(err.response.data.message);
          })
    },
    // getStoreInfo(){
    //  let reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.getStoreAlimtalk)
    //
    //   const params = {"site_name": this.siteName}
    //   console.log(this.siteName)
    //   console.log(reqURL)
    //   console.log("this.currentUser.tokens.access.token")
    //   console.log(this.currentUser.tokens.access.token)
    //
    //   this.$http.get(reqURL, {
    //     headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
    //   }).then(res => {
    //     // ;
    //
    //     if (res.data.code === "OK") {
    //       let tmpItem = res.data.data.status
    //       console.log(res)
    //       if(tmpItem=='UnUse' || !tmpItem){
    //         this.adminToggle = 0
    //       }else if (tmpItem=='Use'){
    //         this.adminToggle = 2
    //       }else {
    //         this.adminToggle = 1
    //       }
    //       this.kakaoIdLabel= res.data.data.kakaoId
    //       this.kakaoNameLabel= res.data.data.kakaoName
    //       this.storeInfo = res.data.data
    //       this.storeSmsRegister= res.data.data.smsRegister
    //       this.storeSendNumber= res.data.data.smsSendNumber
    //       this.storeSmsCertificateDocumentUrl= res.data.data.smsCertificateDocumentUrl
    //       this.storeSmsRegisterDocumentUrl= res.data.data.smsRegisterDocumentUrl
    //     } else {
    //       throw 400
    //     }
    //   }).catch(err => {
    //     alert(err.response.data.message);
    //
    //   })
    // },
    getBrandInfo(){
        let reqURL = ''
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.getBrandalimtalkInfo)
        this.$http.get(reqURL, {
          headers: {
            'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
          }
        }).then(res => {
          if (res.data.code === "OK") {

            this.brandInfo = res.data.data
            this.kakaoIdLabel = res.data.data.kakaoId
            this.kakaoNameLabel = res.data.data.kakaoName
            this.brandSmsRegister = res.data.data.smsRegister
            this.brandSendNumber = res.data.data.smsSendNumber
            this.brandSmsCertificateDocumentUrl = res.data.data.smsCertificateDocumentUrl
            this.brandSmsRegisterDocumentUrl = res.data.data.smsRegisterDocumentUrl
            this.brandCategoryCode = res.data.data.categoryData.categoryCode

            if(this.brandInfo.status=='UnUse'|| !this.brandInfo.status){
              this.adminToggle=0
            }else if(this.brandInfo.status=='Use'){
              this.adminToggle=2
            }else{
              this.adminToggle=1
            }

          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
    },

    recheckAlimTalk(){
      if(this.kakaoIdLabel != null && this.kakaoIdLabel != undefined && this.kakaoIdLabel != ""){
        let chkVal = confirm(`이전에 사용한 카카오톡 채널이 있습니다. (${this.kakaoNameLabel}) \n동일한 카카오톡 채널로 이용 하시겠습니까? (확인) \n신규 카카오톡 채널로 등록 신청 하시겠습니까? (취소)`);
        if(chkVal){
          this.existReapplyAlimtalk();
        }else{
          this.$router.push(`/${this.siteName}/siteSet/AlimtalkReg?reg=REAPPLY`);
        }
      }else{
        this.$router.push(`/${this.siteName}/siteSet/AlimtalkReg?reg=NEW`);
      }

    },
    existReapplyAlimtalk(){
      console.log(this.info.storeCode)
      let reqURL = ''
      let params ={}

        reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.regBrandAlimtalk)
        params = {
          type : "SITE",
          kakaoId : this.kakaoIdLabel,
          // token: this.token,
          // phoneNumber: this.adminNumber,
          smsRegister : this.brandSmsRegister,
          smsSendNumber : this.brandSendNumber,
          smsRegisterDocumentUrl : this.brandSmsRegisterDocumentUrl,
          smsCertificateDocumentUrl : this.brandSmsCertificateDocumentUrl,
          categoryCode : this.brandCategoryCode,
          registerType: "EXISTREAPPLY"
        }


      this.$http.post(reqURL,params,  {
        headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
      }).then(res => {
        // ;
        if (res.data.code === "OK") {
            this.getInfo();
            this.getBrandInfo();

        } else {
          throw 400
        }

      }).catch(err => {
        alert(err.response.data.message);

      })
    },
    brandAlimtalkDisable(){
      let chkVal = confirm("알림톡 사용을 중지하시겠습니까? \n재사용을 원하시는 경우 등록 신청을 다시 진행해 주셔야 합니다.");
      if(chkVal){
        let reqURL = ''
        let params = {}
          reqURL = api.changeAPI(this.siteName, api.basicURL + api.alimtalkMng.brandAlimtalkDisable)
          params = {"brandCode": this.brandCode}

        this.$http.post(reqURL,params, {
          headers: {
            'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
          }
        }).then(res => {
          if (res.data.code === "OK") {
              this.getInfo();
              this.getBrandInfo();

          } else {
            throw 400
          }

        }).catch(err => {
          alert(err.response.data.message);

        })

      }else{
        return
      }

    }

  }
}
</script>

<style scoped>
.testClass{
  background-color: #000000;
  opacity: 0.5;
  overflow: scroll;
}

</style>
